import { render, staticRenderFns } from "./ProblemSelector.vue?vue&type=template&id=5d96093f&scoped=true&"
import script from "./ProblemSelector.vue?vue&type=script&lang=js&"
export * from "./ProblemSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProblemSelector.vue?vue&type=style&index=0&id=5d96093f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d96093f",
  null
  
)

export default component.exports